<template>
  <div>
    <h1>Reviews</h1>
    <v-card class="mb-2">
      <v-card-title>Filter Reviews</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="customer_phone"
              label="เบอร์โทรศัพท์"
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="customer_name"
              label="ชื่อลูกค้า"
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="comment"
              label="ความคิดเห็น"
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mb-4">
      <v-card-title>Average Scores</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-for="score in averageScore"
            :key="score.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card outlined>
              <v-card-title
                :style="{ textAlign: 'center' }"
                class="subtitle-1"
              >
                {{ score.name.th }}
              </v-card-title>
              <v-card-text>
                <v-row
                  justify="center"
                  :style="{ alignItems: 'center' }"
                >
                  <v-rating
                    :value="score.score"
                    color="amber"
                    dense
                    half-increments
                    readonly
                    size="20"
                  ></v-rating>
                  <div class="ml-3 text-center">
                    {{ score.score.toFixed(2) }}
                  </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="reviews"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.scores="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
            >
              <v-rating
                :value="getAverageScore(item.scores)"
                dense
                half-increments
                readonly
                size="20"
              ></v-rating>
            </v-btn>
          </template>
          <span>
            <div
              v-for="score in item.scores"
              :key="score.id"
            >
              {{ score.name.th }}: {{ score.score }}
            </div>
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ formatDateTime(item.createdAt) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'Reviews',
  data() {
    return {
      reviews: [],
      averageScore: [],
      customers: [],
      customer_name: '',
      customer_phone: '',
      comment: '',
      headers: [
        { text: 'เบอร์โทรศัพท์', value: 'customer_phone', align: 'start' },
        { text: 'ชื่อลูกค้า', value: 'customer_name', align: 'start' },
        { text: 'คะแนน', value: 'scores', align: 'center' },
        { text: 'ความคิดเห็น', value: 'comment', align: 'start' },
        { text: 'วันที่', value: 'createdAt', align: 'center' },
      ],
    }
  },
  watch: {
    customer_phone() {
      this.getreviews()
    },
    customer_name() {
      this.getreviews()
    },
    comment() {
      this.getreviews()
    },
  },
  mounted() {
    this.getreviews()
    this.getcustomers()
  },
  methods: {
    formatDateTime(date) {
      if (!date) return ''
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }

      return new Date(date).toLocaleString('th-TH', options)
    },
    getAverageScore(scores) {
      if (!scores || scores.length === 0) return 0
      const totalScore = scores.reduce((sum, score) => sum + score.score, 0)

      return totalScore / scores.length
    },
    async getreviews() {
      const res = await this.axios.get('/reviews', {
        params: {
          customer_phone: this.customer_phone,
          customer_name: this.customer_name,
          comment: this.comment,
        },
      })
      this.reviews = res.data.reviews
      this.averageScore = res.data.averageScoreFactors
      console.log(this.averageScore)
    },
    async getcustomers() {
      const res = await this.axios.get('/employees')
      this.customers = res.data.customers
      console.log(this.customers)
    },
  },
}
</script>
